var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYiflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    width: 600,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 900,
    height: 60,
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 460,
    width: 900,
    height: 60,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450,300)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: 100,
    width: 20,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-60,110 60,110 0,130"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -80,
    width: 10,
    height: 180
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5,-80               A85,85 0 0 1 -75,0               L-65,0               A75,75 0 0 0 -5,-70 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,-80               A85,85 0 0 0 75,0               L65,0               A75,75 0 0 1 5,-70 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5,-60               A65,65 0 0 1 -55,0               L-45,0               A55,55 0 0 0 -5,-50 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,-60               A65,65 0 0 0 55,0               L45,0               A55,55 0 0 1 5,-50 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5,-40               A45,45 0 0 1 -35,0               L-25,0               A35,35 0 0 0 -5,-30 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,-40               A45,45 0 0 0 35,0               L25,0               A35,35 0 0 1 5,-30 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -90,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -10,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -10,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -10,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: -10,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: -10,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: -10,
    width: 10,
    height: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYiflag);
export default __webpack_public_path__ + "static/media/yiflag.ea640459553318ae51d7028a5089cd47.svg";
export { ForwardRef as ReactComponent };